module.exports = __webpack_public_path__ + "static/img/watch3.8f1abd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/watch3.png
// module id = jpGd
// module chunks = 8